export const PopupComponent = {
  bindings: {
    title: '@',
    desc: '@',
  },
  transclude: true,
  templateUrl: 'components/Popup/popup/popup.html',
};
